// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__vzYAw","disabled":"FileBtn_disabled__2ouBa","warn":"FileBtn_warn__1UnL5","fade":"FileBtn_fade__UnbOS"};